import type { DailyMetric, DateRange, Player, SavedPool } from "../types";

export const demoPlayers: Player[] = [
  { id: "lobos-yan", name: "Lobos Yan", teamId: "lobos-performance" },
];

export const demoPools: SavedPool[] = [];

const dateFromIso = (value: string): Date => new Date(`${value}T12:00:00`);
const isoFromDate = (value: Date): string => value.toISOString().slice(0, 10);

const pseudoRandom = (seed: number): number => {
  const x = Math.sin(seed * 12.9898) * 43758.5453;
  return x - Math.floor(x);
};

export const makeDemoRows = (range: DateRange): DailyMetric[] => {
  const start = dateFromIso(range.from);
  const end = dateFromIso(range.to);
  const rows: DailyMetric[] = [];
  let index = 0;

  for (const day = new Date(start); day <= end; day.setDate(day.getDate() + 1)) {
    const active = pseudoRandom(index + 3) > 0.27;
    if (active) {
      const tournaments = 18 + Math.floor(pseudoRandom(index + 11) * 18);
      const entries = tournaments + Math.floor(pseudoRandom(index + 21) * 7);
      const investment = entries * (18 + pseudoRandom(index + 31) * 10);
      const edge = 0.11 + (pseudoRandom(index + 41) - 0.45) * 0.55;
      const profit = investment * edge;
      rows.push({
        date: isoFromDate(day),
        tournaments,
        entries,
        investmentUsd: investment,
        profitUsd: profit,
        cashes: tournaments * (0.27 + pseudoRandom(index + 51) * 0.13),
        hours: null,
      });
    }
    index += 1;
  }

  return rows;
};
